// extracted by mini-css-extract-plugin
module.exports = {"tabsWrapper":"_1OJKmf"};